import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../../directives/sidebar";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import toast, { Toaster } from "react-hot-toast";
import config from "../../config/config";
import { baseurl } from "../../config/config";
import { useParams , useNavigate} from "react-router-dom";
import {
  getCategoryAction,
  getSubCategoryAction,
  getInnerCategoryAction,
  getProductTypeListAction,
  getBrandListAction,
  updateProductAction,
  getProductSizeListAction,
  getProductListAction,
  getProductByIdAndColorProductIdAction,
} from "../../Action/user.action";

const EditProduct = () => {
  let params = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    productName: "",
    description: "",
    customerPrice: "",
    vendorPrice: "",
    marginPrice: "",
    discount: "",
    // color: '',
    // colorProductId: '',
    categoryId: "",
    // subCategoryId: "",
    // innerCategoryId: "",
    // productTypeId: "",
    brandId: "",
    specification: "",
    highlights: "",
    warnings: "",
    userManual: "",
    isSizeAvailable: "",
    productQuantity: "",
    productId: "",
    image1: "",
    image2: "",
    image3: "",
    image4: "",
    image5: "",
    bestQuality: "",
    shippingTime: "",
  });
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [innerCategory, setInnerCategory] = useState([]);
  const [productType, setProductType] = useState([]);
  const [product, setProduct] = useState([]);
  const [brand, setBrand] = useState([]);
  const [sizes, setSize] = useState([]);
  const [categorySizes, setcategorySizes] = useState([]);
  const [oldImages, setoldImages] = useState([]);
  const [defaultQty, setdefaultQty] = useState(false);
  const [qtyBasedOnSize, setqtyBasedOnSize] = useState(false);
  const [isSizeAvailable, setIsSizeAvailable] = useState("");
  const [isSubmitting, setisSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    productName: "",
    price: "",
    image1: "",
    categoryId: "",
    subCategoryId: "",
    brandId: "",
  });
  const [imagePreviews, setImagePreviews] = useState({
    image1: null,
    image2: null,
    image3: null,
    image4: null,
    image5: null,
  });

  const handleQuantityType = (type) => {
    if (type === "0") {
      setIsSizeAvailable("0");
      setdefaultQty(true);
      setqtyBasedOnSize(false);
    } else if (type === "1") {
      setIsSizeAvailable("1");
      setdefaultQty(false);
      setqtyBasedOnSize(true);
    }
  };

  const inputHandler = async (e) => {
    const { name, value } = e.target;


    setForm((old) => {
      return { ...old, [name]: value };
    });


    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `${name} is required` : "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "bestQuality") {
      const newValue = value === "1" ? "1" : "0";
      setForm((old) => {
        return { ...old, [name]: newValue };
      });
    } else {
      setForm((old) => {
        return { ...old, [name]: value };
      });
    }
  };


  useEffect(() => {
    fetchCategoryList();
    // fetchSubCategoryList();
    // fetchInnerCategoryList();
    fetchProductTypeList();
    fetchBrandsList();
    fetchProductsList();
    fetchProductSizeList();

    // fetchProductByIdAndColorProductIdAction()
  }, []);

  const fetchCategoryList = async () => {
    try {
      const res = await getCategoryAction();
      if (res.success) {
        setCategory(res?.data?.filter((item) => item?.status == 1));
      }
    } catch (error) {
      console.error("An error occurred while getting Category:", error);
    }
  };



  const fetchProductTypeList = async () => {
    try {
      const res = await getProductTypeListAction();
      if (res.success) {
        setProductType(res.data);
      }
    } catch (error) {
      console.error("An error occurred while getting Product Type:", error);
    }
  };

  const fetchBrandsList = async () => {
    try {
      const res = await getBrandListAction();
      if (res.success) {
        setBrand(res.data.filter((item) => item.status == 1));
      }
    } catch (error) {
      console.error("An error occurred while getting Brand:", error);
    }
  };

  const fetchProductSizeList = async () => {
    try {
      const res = await getProductSizeListAction();
      if (res.success) {
        setSize(res.data);
      }
    } catch (error) {
      console.error("An error occurred while getting Sizes:", error);
    }
  };


  useEffect(() => {
    let p = sizes.filter((o) => o.categoryId== form.categoryId);
    setcategorySizes(p);
  }, []);

  const fetchProductsList = async () => {
    try {
      const products = await getProductListAction();
      const matchProduct = products.data?.find((item) => item.id == params.id);
      if (matchProduct) {
        setForm({
          ...matchProduct,
        });


        setoldImages({
          image1: matchProduct.images[0],
          image2: matchProduct.images[1],
          image3: matchProduct.images[2],
          image4: matchProduct.images[3],
          image5: matchProduct.images[4],
        });
        setIsSizeAvailable(matchProduct.isSizeAvailable);
        if (matchProduct.isSizeAvailable == 0) {
          setIsSizeAvailable("0");
          setdefaultQty(true);
          setqtyBasedOnSize(false);
        } else if (matchProduct.isSizeAvailable == 1) {
          setIsSizeAvailable("1");
          setdefaultQty(false);
          setqtyBasedOnSize(true);
        }
        setcategorySizes(matchProduct.sizes || []);
      }
    } catch (error) {
      console.error("Error fetching Product detail:", error);
    }
  };


  const [image1, setImage1] = useState([]);
  const [image2, setImage2] = useState([]);
  const [image3, setImage3] = useState([]);
  const [image4, setImage4] = useState([]);
  const [image5, setImage5] = useState([]);

  const [imgDimentionErr, setimgDimentionErr] = useState("");
  const handleImageChange = (e, i) => {
    const selectedImages = e.target.files;
    if (selectedImages.length > 0) {
      const image = selectedImages[0];
      validateImageDimensions(image, selectedImages, i);
    }
  };

  const validateImageDimensions = (image, selectedImages, i) => {
    const img = new Image();
    img.src = URL.createObjectURL(image);

    img.onload = () => {

      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [`image${i}`]: "", // Clear dimension error if dimensions are correct
      }));
      setimgDimentionErr("");


      // If all checks pass, set the image state
      switch (i) {
        case 1:
          setImage1(selectedImages);
          previewImage(selectedImages[0], "image1");
          break;
        case 2:
          setImage2(selectedImages);
          previewImage(selectedImages[0], "image2");
          break;
        case 3:
          setImage3(selectedImages);
          previewImage(selectedImages[0], "image3");
          break;
        case 4:
          setImage4(selectedImages);
          previewImage(selectedImages[0], "image4");
          break;
        case 5:
          setImage5(selectedImages);
          previewImage(selectedImages[0], "image5");
          break;
        default:
          break;
      }
    };
  };

  const previewImage = (file, imageKey) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews((prevPreviews) => ({
          ...prevPreviews,
          [imageKey]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };



  const clearImage = (i) => {
    const imageKey = `image${i}`;

    // Clear local selected images
    switch (i) {
      case 1:
        setImage1([]);
        break;
      case 2:
        setImage2([]);
        break;
      case 3:
        setImage3([]);
        break;
      case 4:
        setImage4([]);
        break;
      case 5:
        setImage5([]);
        break;
      default:
        break;
    }

    // Clear preview and old image
    setImagePreviews((prev) => ({ ...prev, [imageKey]: null }));
    setoldImages((prev) => ({ ...prev, [imageKey]: null }));

    setForm((prevForm) => {
      const updatedImages = (prevForm.images || []).slice(); // clone array
      updatedImages[i - 1] = null; // mark the specific image index as removed
      return {
        ...prevForm,
        images: updatedImages,
      };
    });


    // For image1, show validation error since it's required
    if (i === 1 ) {
      setValidationErrors((prev) => ({
        ...prev,
        [imageKey]: "Image1 is required.",
      }));
    }
  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    setisSubmitting(true);
    if (!validateForm()) {
      setisSubmitting(false);
      return;
    }
    let qtySizeObj = [];
    if (isSizeAvailable == 1) {
      const categorySizesId = categorySizes?.map(({ id, sizeId }) => id || sizeId);
      let totalQty = 0;
      categorySizesId?.map((id) => {
        let obj = {
          sizeId: id,
          quantity: document.getElementById("qtyInput_" + id)?.value,
          onSizePrice: document.getElementById("amtInput_" + id)?.value,
          customerPrice:document.getElementById("custPriceInput_" + id)?.value,
          vendorPrice:document.getElementById("vendorPriceInput_" + id)?.value
        };
        qtySizeObj.push(obj);
        totalQty += parseInt(obj.quantity);
      });
      form.quantity = totalQty;
    }
    let data = {
      ...form,
      productId: params.id,
      image1: image1[0],
      image2: image2[0] ? image2[0] : [],
      image3: image3[0] ? image3[0] : [],
      image4: image4[0] ? image4[0] : [],
      image5: image5[0] ? image5[0] : [],
      isSizeAvailable: isSizeAvailable,
      qtySizeObj: JSON.stringify(qtySizeObj),
    };


    const payload = {
  ...data,
  images: JSON.stringify(data?.images)      // [{ name:"file1.png" }, { name:"file2.png" }]
};

    const res = await updateProductAction(payload);
    if (res.success) {
      toast.success(res.msg);
      setTimeout(() => {
        navigate("/apurva_elec/productList"); // relative path from your routing
      }, 1200);

    } else {
      toast.error(res.msg);
    }
  };

  const validateForm = () => {
    let isValid = true;
    const errors = {
      productName: "",
      customerPrice: "",
      vendorPrice: "",
      image1: "",
      // categoryId: "",
      // subCategoryId: "",
      brandId: "",
    };

    if (form.productName === "") {
      errors.productName = "Product name is required";
      isValid = false;
    }

    if (form.vendorPrice === "") {
      errors.price = "vendor price is required";
      isValid = false;
    }

    if (form.customerPrice === "") {
      errors.price = "customer price is required";
      isValid = false;
    }
    if (form.image1 === "" && !imgDimentionErr) {
      if (imgDimentionErr != "") {
        errors.image1 = imgDimentionErr;
      } else {
        errors.image1 = "Image is required";
      }
      isValid = false;
    }

    if (form.categoryId === "") {
      errors.categoryId = "Category is required";
      isValid = false;
    }



    if (form.brandId === "" || form.brandId == 0) {
      errors.brandId = "Brand name is required";
      isValid = false;
    }

    setValidationErrors(errors);
    if (!isValid) {
      window.scrollTo(0, 0);
    }
    return isValid;
  };

  return (
    <>
      <div className="page">
        <Sidebar />
        <Header />
        <Toaster />
        <div className="content">
          <div className="grid grid-cols-12 gap-6 p-4">
            <div className="col-span-12">
              <div className="box fields">
                <div className="box-header">
                  <h5 className="box-title">Edit Product</h5>
                </div>
                <div className="box-body">
                  <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Product Name
                        </label>
                        <input
                          type="text"
                          className="my-auto ti-form-input"
                          name="productName"
                          placeholder="Product Name"
                          value={form.productName}
                          onChange={handleChange}
                        />
                        <span className="text-red-500 text-sm">
                          {validationErrors.productName}
                        </span>
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Description
                        </label>

                        <textarea
                          className="my-auto ti-form-input"
                          placeholder="Description"
                          name="description"
                          value={form.description}
                          onChange={handleChange}
                        ></textarea>
                      </div>


                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Margin Price
                        </label>
                        <input
                          type="number"
                          className="my-auto ti-form-input"
                          placeholder="Margin Price"
                          name="marginPrice"
                          value={form.marginPrice}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Discount (%)
                        </label>
                        <input
                          type="number"
                          className="my-auto ti-form-input"
                          placeholder="Discount"
                          name="discount"
                          value={form.discount}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Category Name
                        </label>
                        <select
                          className="my-auto ti-form-select"
                          name="categoryId"
                          value={form.categoryId}
                          onChange={handleChange}
                        >
                          <option value="">Select Category</option>
                          {category.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.categoryName}
                            </option>
                          ))}
                        </select>
                        <span className="text-red-500 text-sm">
                          {validationErrors.categoryId}
                        </span>
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">Brand Name</label>
                        <select
                          className="my-auto ti-form-select"
                          name="brandId"
                          value={form.brandId}
                          onChange={handleChange}
                        >
                          <option value="">Select Brand Name</option>
                          {brand
                            .filter(
                              (item) => item.categoryId == form.categoryId
                            )
                            .map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.brandName}
                              </option>
                            ))}
                        </select>
                        <span className="text-red-500 text-sm">
                          {validationErrors.brandId}
                        </span>
                      </div>


                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">Image1*</label>

                        {/* File input shown only when there's no selected or old image */}
                        {!imagePreviews.image1 && !oldImages.image1 && (
                          <input
                            accept="image/x-png,image/gif,image/jpeg,image/webp"
                            type="file"
                            name="image1"
                            className="my-auto ti-form-input"
                            onChange={(e) => handleImageChange(e, 1)}
                          />
                        )}

                        {/* If image is newly selected */}
                        {imagePreviews.image1 && (
                          <div className="relative inline-block mt-2">
                            <img
                              src={imagePreviews.image1}
                              alt="Image Preview"
                              style={{ maxWidth: "200px" }}
                            />
                            <button
                              type="button"
                              onClick={() => clearImage(1)}
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                            >
                              ✕
                            </button>
                          </div>
                        )}

                        {/* If old image exists (from database) */}
                        {!imagePreviews.image1 && oldImages.image1 && (
                          <div className="relative inline-block mt-2">
                            <img
                              src={`${config.imageUrl}${oldImages.image1.name}`}
                              alt="Old Image"
                              style={{ maxWidth: "200px" }}
                            />
                            <button
                              type="button"
                              onClick={() => clearImage(1)}
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                            >
                              ✕
                            </button>
                          </div>
                        )}

                        {/* Validation error */}
                        <span className="text-red-500 text-sm">{validationErrors.image1}</span>
                      </div>


                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Image 2
                        </label>
                        {!imagePreviews.image2 && !oldImages.image2 && (

                          <input
                            accept="image/x-png,image/gif,image/jpeg,image/webp"
                            type="file"
                            name="image2"
                            className="my-auto ti-form-input"
                            onChange={(e) => handleImageChange(e, 2)}
                          />
                        )}

                        {imagePreviews.image2 && (
                          <div className="relative inline-block mt-2">
                            <img
                              src={imagePreviews.image2}
                              alt="Image Preview"
                              style={{ maxWidth: "200px" }}
                            />
                            <button
                              type="button"
                              onClick={() => clearImage(2)}
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                            >
                              ✕
                            </button>
                          </div>

                        )}
                        {!imagePreviews.image2 && oldImages.image2 && (
                          <div className="relative inline-block mt-2">
                            <img
                              src={`${config.imageUrl + oldImages.image2.name}`}
                              alt="image"
                              style={{ maxWidth: "200px" }}
                            />
                            <button
                              type="button"
                              onClick={() => clearImage(2)}
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                            >
                              ✕
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Image 3
                        </label>
                        {!imagePreviews.image3 && !oldImages.image3 && (
                        <input
                          accept="image/x-png,image/gif,image/jpeg,image/webp"
                          type="file"
                          name="image3"
                          className="my-auto ti-form-input"
                          onChange={(e) => handleImageChange(e, 3)}
                        />
                        )}


                        {imagePreviews.image3 && (
                          <div className="relative inline-block mt-2">
                          <img
                            src={imagePreviews.image3}
                            alt="Image"
                            style={{ maxWidth: "200px" }}
                          />
                            <button
                              type="button"
                              onClick={() => clearImage(3)}
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                            >
                              ✕
                            </button>
                          </div>

                        )}
                          {!imagePreviews.image3 && oldImages.image3 && (
                          <div className="relative inline-block mt-2">
                          <img
                            src={`${config.imageUrl + oldImages.image3.name}`}
                            alt="image"
                            style={{ maxWidth: "200px" }}
                          />
                       
                          <button
                              type="button"
                              onClick={() => clearImage(3)}
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                            >
                              ✕
                            </button>
                          </div>
                           )}
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Image 4
                        </label>
                        {!imagePreviews.image4 && !oldImages.image4 && (
                        <input
                          accept="image/x-png,image/gif,image/jpeg,image/webp"
                          type="file"
                          name="image4"
                          className="my-auto ti-form-input"
                          onChange={(e) => handleImageChange(e, 4)}
                        />
                        )}
                        {imagePreviews.image4 && (
                          <div className="relative inline-block mt-2">

                          <img
                            src={imagePreviews.image4}
                            alt="Image Preview"
                            style={{ maxWidth: "200px" }}
                          />
                          <button
                          type="button"
                          onClick={() => clearImage(4)}
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        >
                          ✕
                        </button>
                      </div>

                        )}
                        {!imagePreviews.image4 && oldImages.image4 && (
                          <div className="relative inline-block mt-2">

                          <img
                            src={`${config.imageUrl + oldImages.image4.name}`}
                            alt="image"
                            style={{ maxWidth: "200px" }}
                          />
                           <button
                          type="button"
                          onClick={() => clearImage(4)}
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        >
                          ✕
                        </button>
                      </div>

                        )}
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Image 5
                        </label>
                        {!imagePreviews.image5 && !oldImages.image5 && (

                        <input
                          accept="image/x-png,image/gif,image/jpeg,image/webp"
                          type="file"
                          name="image5"
                          className="my-auto ti-form-input"
                          onChange={(e) => handleImageChange(e, 5)}
                        />
                        )}

                        {imagePreviews.image5 && (
                          <div className="relative inline-block mt-2">

                          <img
                            src={imagePreviews.image5}
                            alt="Image Preview"
                            style={{ maxWidth: "200px" }}
                          />
 <button
                          type="button"
                          onClick={() => clearImage(5)}
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        >
                          ✕
                        </button>
</div>
                        )}
                        {!imagePreviews.image5 && oldImages.image5 && (
                          <div className="relative inline-block mt-2">

                          <img
                            src={`${config.imageUrl + oldImages.image5.name}`}
                            alt="image"
                            style={{ maxWidth: "200px" }}
                          />
                          <button
                          type="button"
                          onClick={() => clearImage(5)}
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        >
                          ✕
                        </button>
                      </div>
                        )}
                      </div>

                      {/* Sizes section start */}
                      <div className="space-y-1 mb-3">
                        <label className="ti-form-label mb-2">
                          Quantity Type
                        </label>
                        <select
                          className="my-auto ti-form-select"
                          name="isSizeAvailable"
                          onChange={(e) => handleQuantityType(e.target.value)}
                          value={isSizeAvailable}
                        >
                          <option value="" disabled>
                            Select Quantity Type
                          </option>

                          {isSizeAvailable == 0 && (
                            <option value="0">
                              Only available in single size
                            </option>
                          )}

                          {isSizeAvailable == 1 && (
                            <option value="1">
                              Quantity based on sizes
                            </option>
                          )}
                        </select>




                      </div>
                      {defaultQty && (
                        <>
                        <div className="space-y-2 mb-3">
                          <label className="ti-form-label mb-2">Quantity</label>
                          <input
                            type="number"
                            className="my-auto ti-form-input"
                            name="productQuantity"
                            placeholder="Product Quantity"
                            value={form.productQuantity}
                            onChange={inputHandler}
                          />
                        </div>
                      {/* // ) : (
                      //   "" */}
                      
                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Customer Price
                        </label>
                        <input
                          type="number"
                          className="my-auto ti-form-input"
                          placeholder="Customer price"
                          name="customerPrice"
                          value={form.customerPrice}
                          onChange={handleChange}
                        />
                        <span className="text-red-500 text-sm">
                          {validationErrors.customerPrice}
                        </span>
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Vendor Price
                        </label>
                        <input
                          type="number"
                          className="my-auto ti-form-input"
                          placeholder="Customer price"
                          name="vendorPrice"
                          value={form.vendorPrice}
                          onChange={handleChange}
                        />
                        <span className="text-red-500 text-sm">
                          {validationErrors.vendorPrice}
                        </span>
                      </div>
                      </>
                      
                      )}
              

{qtyBasedOnSize && (
  <div className="space-y-2 mb-3">
    <label className="ti-form-label mb-2">Add quantity based on size</label>
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Size Name</th>
            <th>Quantity</th>
            <th>Customer Price</th>
            <th>Vendor Price</th>
          </tr>
        </thead>
        <tbody>
          {form.categoryId !== "" ? (
            categorySizes.map((item) => (
              <tr key={item.id || item.sizeId}>
                <td>
                  <input
                    type="text"
                    className="my-auto ti-form-input"
                    readOnly
                    value={item.sizeName}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="my-auto ti-form-input"
                    placeholder="0"
                    defaultValue={item.quantity || ""}
                    id={`qtyInput_${item.id || item.sizeId}`}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="my-auto ti-form-input"
                    placeholder="0"
                    defaultValue={item.customerPrice || 0}
                    id={`custPriceInput_${item.id || item.sizeId}`}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="my-auto ti-form-input"
                    placeholder="0"
                    defaultValue={item.vendorPrice || 0}
                    id={`vendorPriceInput_${item.id || item.sizeId}`}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4}>
                <center>
                  Please select <b>category</b> or <b>sub-category</b> first.
                </center>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}

                      {/* {qtyBasedOnSize ? (
                        <div className="space-y-2 mb-3">
                          <label className="ti-form-label mb-2">
                            Add quantity based on size
                          </label>
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Size Name</th>
                                  <th>Quantity</th>
                                  <th>Additional Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                {form.categoryId != "" ? (
                                  categorySizes?.map((item) => (
                                    <tr>
                                      <td>
                                        <input
                                          type="text"
                                          className="my-auto ti-form-input"
                                          placeholder="Size Name"
                                          readOnly
                                          value={item.sizeName}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="my-auto ti-form-input"
                                          placeholder="0"
                                          defaultValue={item.quantity}
                                         id={`qtyInput_${item?.id || item?.sizeId}`}

                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="my-auto ti-form-input"
                                          placeholder="0"
                                          defaultValue={item.onSizePrice}
                                          id={`amtInput_${item?.id || item?.sizeId}`}
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={3}>
                                      <center>
                                        Please select <b>category</b> or{" "}
                                        <b>sub-category</b> first.
                                      </center>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ) : (
                        ""
                      )} */}

                      {/* Sizes section end */}

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          Specifications
                        </label>
                        <textarea
                          className="my-auto ti-form-input"
                          placeholder="specifications"
                          name="specification"
                          value={form.specification}
                          onChange={handleChange}
                        ></textarea>
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">Highlights</label>
                        <textarea
                          className="my-auto ti-form-input"
                          placeholder="Highlights"
                          name="highlights"
                          value={form.highlights}
                          onChange={handleChange}
                        ></textarea>
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">Warnings</label>
                        <textarea
                          className="my-auto ti-form-input"
                          placeholder="Warnings"
                          name="warnings"
                          value={form.warnings}
                          onChange={handleChange}
                        ></textarea>
                      </div>

                      <div className="space-y-2 mb-3">
                        <label className="ti-form-label mb-2">
                          {" "}
                          User Manual
                        </label>
                        <textarea
                          className="my-auto ti-form-input"
                          placeholder="user manual"
                          name="userManual"
                          value={form.userManual}
                          onChange={handleChange}
                        ></textarea>
                      </div>

                      <div className="space-y-2">
                        <label className="ti-form-label mb-2">
                          Shipping Time
                        </label>
                        <textarea
                          className="my-auto ti-form-input"
                          placeholder="shippingTime "
                          name="shippingTime"
                          value={form?.shippingTime}
                          onChange={handleChange}
                        ></textarea>
                      </div>

                      <div className="space-y-2">
                        <label className="ti-form-label mb-2">
                          Best Quality
                        </label>
                        <input id="yes"
                          type="radio"
                          name="bestQuality"
                          value="1"
                          className="mr-5"
                          onChange={handleChange}
                          checked={form.bestQuality == 1}
                        />
                        <label htmlFor="bestQuality1" className="mr-5">
                          YES
                        </label>
                        <input
                          id="no"
                          type="radio"
                          name="bestQuality"
                          value="0"
                          className="mr-5"
                          onChange={handleChange}
                          checked={form.bestQuality == 0}
                        />
                        <label htmlFor="bestQuality0" className="mr-5">
                          NO
                        </label>
                      </div>
                    </div>
                    <button type="submit" className="ti-btn ti-btn-primary">
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default EditProduct;
